import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { uriFor } from '../utils/typeResolver';
import Layout from '../recordViews/Layout';
import { Http } from '../utils/http';
import { centsToString } from '../utils/currency';
import { IAppContext } from '../context/AppContext';
import { PageRoute } from '../models/PageRoute';

export const DigitalCopyCartSummaryPage: React.FC<PageRoute> = (route: PageRoute) => {
  const removeItem = (id: number, context: IAppContext): void => {
    Http.get()
      .removeFromCart(id)
      .then(() => {
        context.refreshCart();
      })
      .catch((exception: Error) => {
        console.error(exception);
      });
  };

  const context = route.context;

  const findDuplicates = (arr: any[]) => arr.filter((item, index) => arr.indexOf(item) != index)
  
    const cartDuplicates = () => {
        if (!context.cart) {
            return;
        }

        const controllingQuotableRecords = context.cart.digital_copy_requests.quotable_records;
        const controllingRecordQuotableIds: any[] = []
        const controllingSetPrice = context.cart.digital_copy_requests.set_price_records
        const controllingSetPriceIds: any[] = []

        controllingSetPrice.map((parent_records: any) => (
            controllingSetPriceIds.push(parent_records.record.controlling_record.qsa_id_prefixed)
        ))
        controllingQuotableRecords.map((parent_records: any) => (
            controllingRecordQuotableIds.push(parent_records.record.controlling_record.qsa_id_prefixed)
        ))
        if (findDuplicates(controllingRecordQuotableIds).length > 0 || findDuplicates(controllingSetPriceIds).length > 0) {
            return (
                <div className="alert alert-warning" role="alert">
                    <p>
                        There are duplicate items in your cart. Please refer to the above message and remove duplicate items before continuing.
                    </p>
                </div>
            )
        }
    }

  if (!context.user) {
    if (context.sessionLoaded) {
      return <Layout noindex={true}>
        <h1>
            <i className="fa fa-copy" aria-hidden="true" />&nbsp; Your Digital Copy Requests
        </h1>
        <div className="alert alert-warning">Please log in to access your cart</div>

      </Layout>;
    } else {
      return <></>;
    }
  }

  return (
    <Layout noindex={true}>
      <div className="row">
        <div className="col-sm-12">
          <h1>
            <i className="fa fa-copy" aria-hidden="true" />&nbsp; Your Digital Copy Requests
          </h1>
          <div className="alert alert-success" role="alert">
            <h2>
            <i className="fa fa-comments" />
            If two or more of the items in your cart have the same  ITM number in the “PARENT ITEM” column, please remove the additional items so that you are only ordering one copy of 	the item.
            </h2>
            <p>
            Many items in our collection have more than one Physical Representation for the same item (eg. the original item and a microfilm copy of that item). In this case, each Physical Representation will have a different PR number, but because they are the same item they will have the same ITM number - so you only need to request one of these, not both. 
            </p>
          </div>
          {cartDuplicates()}
          {(function () {
            const location = useLocation();

            if (location.state && location.state.flash) {
              return <div className="alert alert-success">{location.state.flash}</div>;
            } else if (!context.cart || context.cart.digital_copy_requests.total_count === 0) {
              return <div className="alert alert-info">Cart empty</div>;
            }
          })()}

          {context.cart && context.cart.digital_copy_requests.total_count > 0 && (
            <>
              <table className="table table-bordered table-condensed">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Title</th>
                    <th>Parent Item</th>
                    <th className="column-right-align">Price</th>
                    <th><span className="sr-only">Actions</span></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    (context.cart.digital_copy_requests.set_price_records.concat(context.cart.digital_copy_requests.quotable_records)).map((cartItem: any) => (
                      <tr key={cartItem.id}>
                        <td>
                          <span className="badge badge-info">
                            {cartItem.digital_copy_request_type === 'QUOTE_REQUIRED' ? 'Requires Quote' : 'Set Price'}
                          </span>
                        </td>
                        <td>{cartItem.record.display_string}</td>
                        <td>
                          <Link to={uriFor(cartItem.record.controlling_record.qsa_id_prefixed, 'archival_object')}>
                            {cartItem.record.controlling_record.qsa_id_prefixed}
                          </Link>
                        </td>
                        <td className="column-right-align">{cartItem.digital_copy_request_type === 'SET_PRICE' ? centsToString(cartItem.price) : 'TBC' }</td>
                        <td className="column-right-align">
                          <button
                            className="qg-btn btn-default btn-xs"
                            onClick={e => {
                              e.preventDefault();
                              removeItem(cartItem.id, context);
                            }}>
                            <i className="fa fa-trash" aria-hidden="true" />&nbsp; Remove item</button>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>

              <div className="checkout-actions mt-5">
                {context.cart.digital_copy_requests.set_price_records.length > 0 &&
                  <Link to="/digital-copies-cart/set-price-checkout" className="qg-btn btn-primary">
                    Checkout Set Price copies
                  </Link>
                }

                {context.cart.digital_copy_requests.quotable_records.length > 0 &&
                  <Link to="/digital-copies-cart/request-quote" className="qg-btn btn-primary">
                    Request Quotes
                  </Link>
                }

                <button
                  className="qg-btn btn-default"
                  onClick={e => {
                    e.preventDefault();
                    Http.get()
                        .clearCart('DIGITAL_COPY')
                        .then(() => context.refreshCart());
                  }}>Clear cart</button>
              </div>
            </>
          )}

          <p>
            <small><Link to="/digital-copies-cart/minicart">View your QGov Cart</Link></small>
          </p>
        </div>
      </div>
    </Layout>
  );
}

